export default {
  findClass: {
    method: 'get',
    url: 'classes{/id}'
  },
  updateClass: {
    method: 'post',
    url: 'classes'
  },
  deleteClass: {
    method: 'delete',
    url: 'classes{/id}'
  }
}